export default () => {
  const { $t } = useNuxtApp()
  const listStatus = [
    {
      value: 0,
      label: $t('labels.init')
    },
    {
      value: 1,
      label: $t('labels.quoteCreated')
    },
    {
      value: 3,
      label: $t('labels.cancel')
    }
  ]

  return listStatus
}
